import React from 'react';
import Divider from '@material-ui/core/Divider';
import strings from 'strings';
import Text from 'UI/components/atoms/Text';
import { BulkFormFieldGrid } from 'UI/components/organisms/BulkEmailForm/components/BulkFormFieldGrid';
import { getOrdinalSuffix } from 'UI/utils';

import { useSequencesPreviewSections } from '../../hooks/useSequencesPreviewSections';
import { BulkEmailSectionsCollapser } from '../BulkEmailSectionsCollapser';

import { useBulkEmailDrawerSequencesPreviewStyles } from './BulkEmailDrawerSequencesPreview.styled';

const { sequences: sequencesCopies } = strings.bulkEmails.forms;

export const BulkEmailDrawerSequencesPreview = ({ currentStep }) => {
  const classes = useBulkEmailDrawerSequencesPreviewStyles();
  const sections = useSequencesPreviewSections();

  return sections.map((section, index) => {
    const isFirstSection = index === 0;
    const isLastElement = sections.length - 1 === index;
    const finalStep = (currentStep || 1) + index;
    const ordinalStepString = getOrdinalSuffix(finalStep);

    return (
      <BulkEmailSectionsCollapser
        key={section.key}
        title={strings.formatString(sequencesCopies.sections.title, {
          attempt: ordinalStepString
        })}
        shouldShowBottomDivider={isLastElement}
        shouldShowCollapseButton
        shouldShowTitle
        shouldShowTopDivider={!isFirstSection}
      >
        <BulkFormFieldGrid label={sequencesCopies.preview.headerLabels.to} field={section.to} />
        <BulkFormFieldGrid label={sequencesCopies.preview.headerLabels.from} field={section.from} />
        <BulkFormFieldGrid
          label={sequencesCopies.preview.headerLabels.subject}
          field={section.subject}
        />
        <Divider className={classes.divider} />
        <Text text={section.emailBody} variant="body1" />
      </BulkEmailSectionsCollapser>
    );
  });
};
